<template>
  <v-app id="inspire">
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>

            <v-row>
                <v-col md="12" lg="12" cols="12">
                    <v-card  color="#393E46">
                      <v-card-title>Bajar Lista en Excel</v-card-title>
                      <v-card-text>
                      <v-row>
                        <v-col md="3" lg="3" cols="12">
                            <v-autocomplete
                              v-model="idfiesta"
                              :items="fiestas"
                              item-text="nombre"
                              item-value="id"
                              label="Escoge Fiesta"
                              @change="cambia"
                              persistent-hint
                              single-line
                            ></v-autocomplete>
                        </v-col>
                        <v-col md="3" lg="3" cols="12">
                            <vue-excel-xlsx
                                class="btn"
                                :data="listas"
                                :columns="columns"
                                :fileName="'Lista'"
                                :sheetName="'Lista'"
                            >
                            <v-btn style="background-color: #6D9886;"> Bajar Excel</v-btn>
                            </vue-excel-xlsx>
                        </v-col>
                      </v-row>
                      </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row >
              <v-col md="12" lg="12" cols="12">
                <v-alert
                :value="alertborrador"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
              >
              Su Invitado se borro con éxito.
               </v-alert>
                <v-data-table
                :headers="headers"
                :items="listas"
                class="elevation-1"
                sort-by="id"
                sort-desc
                :search="search"

                loading-text="Cargando... Por favor espere"
                style="background-color: #393E46;"
               >
                  <template v-slot:top>
              <v-toolbar
                  flat
              >
                <v-toolbar-title>Lista</v-toolbar-title>
                <v-progress-circular
              indeterminate
              v-if="progr === true"
              color="primary"
            ></v-progress-circular>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogdelete" persistent max-width="350">
              <v-card>
                <v-card-title class="headline">Desea eliminar esta persona de la Fiesta?</v-card-title>
                <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="close">No</v-btn>
                  <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
              </v-toolbar>
            </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-icon
                        small
                        color="error" class="mr-2"
                        @click="deleteItem(item)"
                    >
                        fas fa-minus-circle
                    </v-icon>
                      <v-icon
                              v-if="item.idPersona > 0"
                              small
                              color="white"
                              class="mr-2"
                              @click="verQr(item)"
                      >
                          fas fa-qrcode
                      </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="damelistas">Cargar de Nuevo</v-btn>
                  </template>
                </v-data-table>
            </v-col>
          </v-row>
        <leftmenu :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
       </v-container>
    </v-main>

  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Listas Promotores | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      overlay: false,
      idnegocio: '',
      negocio: { negocioId: '1', negocio: 'Gotica', clienteId: '1', Activo: false, Icono:'https://tunay.app/imagenes/negocios/b2ac86e6f0e58dfc24238ded27e1dc89e86a64c4.jpg',Logo:'https://tunay.app/imagenes/negocios/bcd1019c2336540d12cd0d68fcde7ce7fb43c7e0.jpg', impuesto:'0',idMoneda:'0',paisId:'173',tag:'gotica',latitud:'-12.1325729',longitud:'-77.0324181',horaApertura:'22:00:00', horaCierre:'00:00:00', tipoNegocioId:'2',Direccion:'',mailreserva:'',facebook:'',instagram:'',Ciudad:'Lima', Distrito:'Miraflores',temporadaactivaId:0,temporadaactivaNombre:''},
      idfiesta: 0,
      idfiestaxls:0,
      idtipolista: 0,
      fiestas:[],
      tiposlista: [],
      bajaremos: [],
      token:'',
      columns : [
                    {
                        label: "Nombre",
                        field: "nombre",
                    },
                    {
                        label: "Promotor",
                        field: "promotor",
                    },
        {
          label: "Tipo de Lista",
          field: "tipoLista",
        },

        { label: 'Codigo Unico', field: 'codigoUnico' },

                ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
      menu1: false,
      listas: [],
      abreviado:'NN',
      search: '',
      editedIndex: -1,
      editedItem: {
        listaDetalleId: 0,
        listaDTO:{
          listaId:0,
          listaTitular:'',
          promotorId: 0,
          promotorNombre:'',
          promotorCabezaId:0,
          promotorCabezaNombre:'',
          negocioId:0,
          negocioNombre:'',
          fiestaId:0,
          fiestaNombre:'',
          fiestaFecha: null,
          fiestaActiva:true,
          tipoListaId:0,
          tipoListaNombre: '',
          clienteId:0,
          clienteNombre:'',
          diaId:0,
          diaNombre:''
        },
        nombre: '',
        dni: '',
        fechaIngreso: '',
        f: true,
        dateCreated: null
      },
      defaultItem: {
        listaDetalleId: 0,
        listaDTO:{
          listaId:0,
          listaTitular:'',
          promotorId: 0,
          promotorNombre:'',
          promotorCabezaId:0,
          promotorCabezaNombre:'',
          negocioId:0,
          negocioNombre:'',
          fiestaId:0,
          fiestaNombre:'',
          fiestaFecha: null,
          fiestaActiva:true,
          tipoListaId:0,
          tipoListaNombre: '',
          clienteId:0,
          clienteNombre:'',
          diaId:0,
          diaNombre:''
        },
        nombre: '',
        dni: '',
        fechaIngreso: '',
        f: true,
        dateCreated: null
    },
    headers: [
            { text: 'Acciones', value: 'action', sortable: false },
            { text: 'Nombre', align: 'left',  value: 'nombre'},
            { text: 'Codigo Unico', value: 'codigoUnico' },
            { text: 'Promotor', value: 'promotor' },
            { text: 'Fiesta', value: 'nombreActo' },
            { text: 'Tipo de Lista', value: 'tipoLista' },
          ]
  }),
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio
    this.negocio = this.negocios.find(x=>x.tag === this.idnegocio)
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.damefiestas();
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
          }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.damefiestas();
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

          }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);

           this.idnegocio =  this.$route.params.idnegocio
               this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
       if (this.usuario.id === undefined){
         this.$router.push({name: 'homepage'});
       }else{
         this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
         this.damefiestas();
          }
    },
  },
  methods : {
    cambia(){
      this.damelistas();
    },
    damefiestas(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.fiestas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          this.damelistas();
        })
        .catch((error)  => {
        console.error(error);
          this.overlay = false
        });
    },
     dametiposlista(){
      this.progr = true;
       this.overlay = true
            let urltipolista = 'tipolistas/negocio/' + this.idnegocio ;
        axios
        .get(urltipolista,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.tiposlista = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
        })
        .catch((error)  => {
        console.error(error);
          this.overlay = false
          this.progr = false
        });
    },
    damelistas(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('fId', this.idfiesta);
      bodyFormData.append('nTg', this.idnegocio);
      this.overlay = true
      axios
        .post('lista/fiesta/negocio',bodyFormData,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.listas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            if (this.listas.length>0){
          this.idfiesta = this.listas[0].actoId
            }
          this.overlay = false
          this.dametiposlista()
        })
        .catch((error)  => {
        console.error(error);
          this.overlay = false;
          this.progr = false;
        });
    },
    damelistasxls(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('fId', this.idfiesta);
      bodyFormData.append('lDi', this.idtipolista);
      this.overlay = true
      axios
          .post('lista/fiesta/excel',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.bajaremos = response.data;
            this.overlay = false
            this.progr = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
            this.progr = false
          });
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },
      verQr (item) {
          let ssalink = "https://tunay.app/eqr/"+item.codigoUnico
          var anchor = document.createElement('a');
          anchor.href = ssalink;
          anchor.target="_blank";
          anchor.click();
      },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    borralo (){
      axios
      .delete('lista/'+this.listas[this.editedIndex].codigoUnico,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.damefiestas();
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
